<template lang="pug">
  section.section

    .greeting(v-if="$store.getters.registered") Hi {{ $store.state.user.username }}, hier sind Deine Listen:
    br

    slide-y-down-transition
    ul.my-lists
      li(v-for="list in lists", :key="list.id")
        router-link(:to="'/' + list.token") {{ list.title }}
        a.is-pulled-right(href="#", @click="deleteList(list)")
          b-icon(icon="delete")
    br

    .add-a-list
      button.button.is-primary(@click="addNewList") + neue Liste
</template>

<script>
// @ is an alias to /src

export default {
  name: 'my-lists',
  components: {
  },
  data () {
    return {
      lists: []
    }
  },
  created () {
    this.loadLists()
  },
  methods: {
    loadLists: function () {
      this.axios.get('/lists').then(response => (this.lists = response.data))
    },
    reallyDeleteList: function (list) {
      this.axios.delete('/lists/' + list.id).then(response => {
        this.loadLists()
        this.$toast.open({
          message: 'Wunschliste gelöscht!',
          type: 'is-success'
        })
      }).catch(response => console.log(response))
    },
    deleteList: function (list) {
      if (list.items.length > 0 || list.description) {
        this.$dialog.confirm({
          title: 'Wunschliste löschen',
          message: 'Bist Du wirklich sicher?',
          confirmText: 'Wunschliste löschen',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => this.reallyDeleteList(list)
        })
      } else this.reallyDeleteList(list)
    },
    addNewList: function () {
      this.axios.post('/lists', { user: this.$store.state.user.id })
        .then(response => this.loadLists()).catch(response => console.log(response))
    }
  }
}
</script>

<style lang="sass" scoped>
  ul
    display: block
    list-style-type: circle
    list-style-position: inside
    li
      line-height: 30px
</style>
